import { memo, useCallback } from 'react';
import {
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming,
} from 'react-native-reanimated';
import { Trans } from 'react-i18next';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { StatusChangeProps } from './StatusChange.types';

function StatusChange({
  heading,
  subheading,
  title,
  description,
  buttonText,
  renderAnimation,
  onButtonPress,
  ...rest
}: StatusChangeProps) {
  const animatedValue = useSharedValue(0);
  const animatedStyle = useAnimatedStyle(
    () => ({
      opacity: animatedValue.value,
    }),
    [],
  );

  const onAnimationEnd = useCallback(() => {
    'worklet';
    animatedValue.value = withDelay(200, withTiming(1));
  }, [animatedValue]);

  return (
    <Box {...rest}>
      <Box
        animatedStyle={animatedStyle}
        paddingHorizontal="space-600"
        gap="space-200"
      >
        <Text variant="overline" color="darkSurfacePrimary" textAlign="center">
          {heading}
        </Text>
        <Text variant="h2" color="darkSurfacePrimary" textAlign="center">
          {subheading}
        </Text>
      </Box>
      {renderAnimation(onAnimationEnd)}
      <Box
        animatedStyle={animatedStyle}
        paddingHorizontal="space-600"
        gap="space-300"
      >
        <Box padding="space-300" paddingTop="space-800" gap="space-400">
          {title ? (
            <Text
              variant="body-m-semi"
              color="darkSurfacePrimary"
              textAlign="center"
            >
              {title}
            </Text>
          ) : undefined}
          {description ? (
            <Text
              variant="body-s"
              color="darkSurfacePrimary"
              textAlign="center"
            >
              <Trans
                components={{
                  b: <Text variant="body-s-semi" />,
                }}
              >
                {description}
              </Trans>
            </Text>
          ) : undefined}
        </Box>
      </Box>
      <Button
        text={buttonText}
        marginHorizontal="space-600"
        marginTop="space-600"
        onPress={onButtonPress}
      />
    </Box>
  );
}

export default memo(StatusChange);
